<template>
	<div class="info-section" :class="{ 'is-closeable': isCloseable }">
		<div @click="onClose">
			<CloseButton v-if="isCloseable" class="close-button-container" />
		</div>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'InfoSection',
	props: {
		isCloseable: { type: Boolean, default: false },
	},
	methods: {
		onClose() {
			this.$emit('onClose');
		},
	},
	data() {
		return {
			isClosed: false,
		};
	},
};
</script>

<style scoped lang="scss">
.info-section {
	position: relative;
	padding: 4px 8px;
	background-color: var(--light-bg-color);
	color: #666666;
	border-radius: 6px;
	border: var(--fifth-border);

	.close-button-container {
		position: absolute;
		top: 4px;
		right: 4px;
	}

	&.is-closeable {
		padding: 8px 10px 4px 8px;
	}
}
</style>
